const cacheTimeout = 10000;

export default cacheTimeout;
